import { Link } from "react-router-dom";
import { Phone, Mail, MapPin, Leaf } from "lucide-react";

export default function Footer({ settings }) {
  const phoneTel = settings?.phone_tel || "+12894421265";
  const phone = settings?.phone || "+1 (289) 442-1265";
  return (
    <footer className="bg-emerald-950 text-stone-200 mt-0" data-testid="site-footer">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-12 py-16 grid gap-10 md:grid-cols-4">
        <div className="md:col-span-2">
          <div className="flex items-center gap-2 mb-4">
            <span className="w-9 h-9 rounded-full bg-emerald-800 flex items-center justify-center"><Leaf size={18} /></span>
            <span className="font-serif text-xl text-amber-50">Healthy Roots</span>
          </div>
          <p className="text-sm text-stone-300 max-w-md leading-relaxed">
            {settings?.footer_text || "We are Holistic Practitioners who believe that our body is created to heal itself. We address the root cause through diet and lifestyle."}
          </p>
        </div>
        <div>
          <h4 className="font-sans font-semibold text-amber-50 mb-4 text-sm uppercase tracking-wider">Explore</h4>
          <ul className="space-y-2 text-sm">
            {[["Home", "/"], ["About Us", "/about-us"], ["Services", "/services"], ["Recipes", "/recipes"],
              ["Blog", "/blog"], ["Testimonials", "/testimonials"], ["Media", "/media"], ["Contact", "/contact"]].map(([l, u]) => (
              <li key={u}><Link to={u} className="text-stone-300 hover:text-amber-200 transition-colors">{l}</Link></li>
            ))}
          </ul>
        </div>
        <div>
          <h4 className="font-sans font-semibold text-amber-50 mb-4 text-sm uppercase tracking-wider">Get in touch</h4>
          <ul className="space-y-3 text-sm font-mono">
            <li><a href={`tel:${phoneTel}`} className="flex items-center gap-2 hover:text-amber-200"><Phone size={14} /> {phone}</a></li>
            <li><a href={`mailto:${settings?.email || "healthyroots4wellness@gmail.com"}`} className="flex items-center gap-2 hover:text-amber-200"><Mail size={14} /> {settings?.email || "healthyroots4wellness@gmail.com"}</a></li>
            <li className="flex items-center gap-2"><MapPin size={14} /> {settings?.address || "Hamilton, Ontario, Canada"}</li>
          </ul>
        </div>
      </div>
      <div className="border-t border-emerald-800/60 py-5 text-center text-xs text-stone-400 px-4">
        © {new Date().getFullYear()} Healthy Roots Holistic Practitioners Ltd. All rights reserved. ·{" "}
        <Link to="/admin" className="hover:text-amber-200">Staff Login</Link>
      </div>
    </footer>
  );
}
